import {useState, useEffect, memo} from 'react';
import ReactDOM from 'react-dom';
import { BsPersonCircle as ProfilePicture } from 'react-icons/bs';
import ProfileBanner from '@ManagementViews/ProfileBanner';
import Popover from '@mui/material/Popover';
import Avatar from '@mui/material/Avatar';
import { useReduxUsers } from '@Hooks/reduxUsersHook/useReduxUsers';
import ErrorHandler from '@Root/ErrorHandler';
import './UserAvatar.scss';

function UserAvatar(props) {

    const [photo, setPhoto] = useState('');
    const [user, setUser] = useState({});
    const [userId, setUserId] = useState(0);
    const [unassigned, setUnassigned] = useState(true);
    const [showName, setShowName] = useState(false);
    const [, setImageUrl] = useState('');
    const [anchorAssigneeInfoPopover, setAnchorAssigneeInfoPopover] = useState(null);
    const { getUserByIdAndFetch } = useReduxUsers();
    const colorList = ['#2784B9', '#40c47d', '#FDB16C', '#b06060', '#f77474', '#6080b0', '#9a60b0', '#6cb060',
        '#b0ae60', '#65412b', '#cc9963', '#e1bd83', '#60748b', '#744700', '#c8d579', '#5f8fba', '#3e6073', '#8e6dc1', '#473785',
       '#9158a9',  '#7f3f7a', '#583e84', '#073763', '#20124d', '#3d124d', '#64113f', '#780448', '#003e23', '#108764', '#1a4c3d',
        '#c8d77f', '#11888b', '#1a95bd', '#0d6c7b', '#25b56e', '#006e3d'];
    const errorHandler = new ErrorHandler();
    const className = 'profileBanner';

    useEffect(() => {
        renderData();
    }, [props])

    const renderData = async () => {
        try {
            setShowName(!!props.showName ? props.showName : false);
            if(props?.profileId && props?.profileId > 0) {
                await renderUserData();
            }
        } catch (err) {
            errorHandler.handleError(err);
        }
    }

    const getInitials = (string) => {
        if(!!string && string.length > 0) {
            string = string.trim();
            var names = string?.split(' '),
                initials = names[0]?.substring(0, 1)?.toUpperCase();
            if (names?.length > 1) {
                initials += names[names?.length - 1]?.substring(0, 1)?.toUpperCase();
            } else {
                names = string?.split('@');
                initials = names[0]?.substring(0, 1)?.toUpperCase();

                if (names?.length > 1) {
                    initials += names[names?.length - 1]?.substring(0, 1)?.toUpperCase();
                }
            }
            return initials;
        }
        return 'N/A';
    };

    const renderUserData = async() => {
        var loadLoops = 0, loadingError = false, errorException;
        for(loadLoops = 0; loadLoops < 10; loadLoops++) {
            try {
                let userObj = await getUserByIdAndFetch(props?.profileId);
                ReactDOM.unstable_batchedUpdates(() => {
                    setUser(userObj);
                    setUserId(props?.profileId);
                    setPhoto( !userObj.photo || userObj.photo === 'null' ? '' : userObj.photo);
                    setImageUrl( !userObj.photo || userObj.photo === 'null' ? '' : userObj.photo );
                    setUnassigned(false);
                });
                loadingError = false;
                break;
            } catch (err) {
                errorHandler.logError('User Data', err);
                loadingError = true;
                errorException = err;
            }
        }
        if(loadLoops === 10 && loadingError === true) {
            errorHandler.handleError(errorException);
            return false;
        }
        return true;
    }

    const handleAssigneeInfoPopoverOpen = (event) => {
        if (props?.popover && !unassigned) {
            setAnchorAssigneeInfoPopover(event.currentTarget);
        }
    };

    const handleAssigneeInfoPopoverClose = () => {
        setAnchorAssigneeInfoPopover(null);
    };

    const splitUserNames = (user)=> {
        if(!!user && user !== null) {
            let userName = user?.fullName?.trim();
            let parts = userName?.split(' ');
            if(!!parts && parts?.length > 1){
                let nameString = (!!parts ? parts[0] : user?.fullName) + ' ';
                nameString += parts?.length > 1 ? parts[parts.length - 1][0] + '.' : user?.fullName?.charAt(0) + '.';
                return nameString;
            }
            return user?.fullName;
        }
    }

    return(
        <div className = {className + '__avatar flex-row-center-0p5rem-gap'} style={{...props.style}}
            onMouseEnter={handleAssigneeInfoPopoverOpen}
            onMouseLeave={handleAssigneeInfoPopoverClose}
            onClick={props?.onClick}>
            {
                !!props.system ?
                    <>
                        <Avatar
                            sx={{
                                bgcolor: colorList['System'?.charCodeAt(0) % colorList?.length] + ' !important',
                                width: (props?.size === 'large' ? 40 : (props?.size === 'medium' ? 30 : 20)),
                                height: (props?.size === 'large' ? 40 : (props?.size === 'medium' ? 30 : 20))
                            }}>
                            {'System' ? 'S' : 'UA'}
                        </Avatar>
                        <div className={className + '__avatar__userName'}>
                            {splitUserNames({fullName: 'System'})}
                        </div>
                    </>
                :
                <>
                    {
                        !!photo && photo !== '' ?
                            <Avatar
                                src={photo}
                                sx={{
                                    width: (props?.size === 'large' ? 40 : (props?.size === 'medium' ? 30 : 20)),
                                    height: (props?.size === 'large' ? 40 : (props?.size === 'medium' ? 30 : 20))
                                }}
                            />
                        :
                            props?.unassigned ?
                                <Avatar
                                    sx={{
                                        bgcolor: colorList[user?.fullName?.charCodeAt(0) % colorList?.length] + ' !important',
                                        width: (props?.size === 'large' ? 40 : (props?.size === 'medium' ? 30 : 20)),
                                        height: (props?.size === 'large' ? 40 : (props?.size === 'medium' ? 30 : 20))
                                    }}>
                                    {user?.fullName ? getInitials(user?.fullName) : 'UA'}
                                </Avatar>
                            :
                                <Avatar
                                    src=<ProfilePicture/>
                                    sx={{
                                        width: (props?.size === 'large' ? 40 : (props?.size === 'medium' ? 30 : 20)),
                                        height: (props?.size === 'large' ? 40 : (props?.size === 'medium' ? 30 : 20))
                                    }}
                                />
                    }
                    {
                        showName &&
                            <div className={className + '__avatar__userName'}>
                                {splitUserNames(user)}
                            </div>
                    }
                    {
                        props?.popover &&
                            <Popover
                                id='mouse-over-info'
                                sx={{
                                    pointerEvents: 'none',
                                }}
                                open={Boolean(anchorAssigneeInfoPopover)}
                                anchorEl={anchorAssigneeInfoPopover}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                onClose={handleAssigneeInfoPopoverClose}
                                onRequestClose={handleAssigneeInfoPopoverClose}>
                                <ProfileBanner
                                    profileId={userId}/>
                            </Popover>
                    }
                </>
            }
        </div>
    );
}

export default memo(UserAvatar, arePropsEqual)

function arePropsEqual(oldProps, newProps) {
    return (
        oldProps?.profileId === newProps?.profileId
    )
}